export default __webpack_public_path__ + "static/media/banner_bg.2360e98c.png";